import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-gamification-ranking-card',
  templateUrl: './gamification-ranking-card.component.html',
  styleUrls: ['./gamification-ranking-card.component.scss'],
})
export class GamificationRankingCardComponent implements OnInit {
  @Output()
  openPositionModal = new EventEmitter<boolean>();

  @Output()
  openScoreModal = new EventEmitter<boolean>();

  @Input()
  currentPosition: number | string;
  @Input()
  totalPosition: number;
  @Input()
  currentPoints: number;

  private readonly configService = inject(ConfigService);
  private readonly breakpointObserver = inject(BreakpointObserver);

  readonly showRanking = signal(this.configService.get().gmfConfig.showRanking);
  readonly scoreLabel = signal<string>(this.configService.get().customLabels.ranking.scoreLabel ?? 'user.ranking.points.title');

  vertical = signal<boolean>(false);
  bpObserver = new Subject<void>();

  ngOnInit(): void {
    if (this.currentPoints === 0) {
      this.currentPosition = '--';
    }

    this.breakpointObserver.observe('(max-width: 767px)')
      .subscribe((result) => {
        this.vertical.set(result.matches ? false : true);
      });
  }
}
